import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { DefaultSameCenterLimit, useSameCenterChildAvailability } from '@sola/my-sdk/children/hooks.ts';
import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
export const useDepartureSubChildSearchSheet = departingChildDetails => {
  const $ = _c(34);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["my"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const childName = departingChildDetails.name.preferred || departingChildDetails.name.first;
  let t1;
  if ($[1] !== departingChildDetails.globalId || $[2] !== departingChildDetails.icp.id) {
    t1 = {
      centerId: departingChildDetails.icp.id,
      excludeChildId: departingChildDetails.globalId
    };
    $[1] = departingChildDetails.globalId;
    $[2] = departingChildDetails.icp.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const sameCenterChildrenQuery = useSameCenterChildAvailability(t1);
  let t2;
  if ($[4] !== sameCenterChildrenQuery.data) {
    t2 = sameCenterChildrenQuery.data ?? [];
    $[4] = sameCenterChildrenQuery.data;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = sameCenterChildrenQuery.isLoading;
  const t4 = sameCenterChildrenQuery.isSuccess && sameCenterChildrenQuery.data.length > 0;
  let t5;
  if ($[6] !== childName || $[7] !== t) {
    t5 = t("my:sponsorshipRelationship.departures.subChildSearchSheet.sameCenter.badge", {
      childName
    });
    $[6] = childName;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("my:sponsorshipRelationship.departures.subChildSearchSheet.title");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== childName || $[12] !== t) {
    t7 = t("my:sponsorshipRelationship.departures.subChildSearchSheet.sameCenter.heading", {
      childName
    });
    $[11] = childName;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("my:sponsorshipRelationship.departures.subChildSearchSheet.sameCenter.body");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== childName || $[17] !== t) {
    t9 = t("my:sponsorshipRelationship.departures.subChildSearchSheet.sameCenter.loading", {
      childName
    });
    $[16] = childName;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("my:sponsorshipRelationship.departures.subChildSearchSheet.search.heading");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("my:sponsorshipRelationship.departures.subChildSearchSheet.search.body");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== sameCenterChildrenQuery.isLoading || $[24] !== t10 || $[25] !== t11 || $[26] !== t2 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t12 = {
      sameCenterChildren: t2,
      sameCenterChildrenLoading: t3,
      hasSameCenterChildren: t4,
      sameCenterSkeletonCount: DefaultSameCenterLimit,
      sameCenterBadgeText: t5,
      title: t6,
      sameCenterTitle: t7,
      sameCenterBody: t8,
      sameCenterLoadingLabel: t9,
      searchTitle: t10,
      searchBody: t11
    };
    $[23] = sameCenterChildrenQuery.isLoading;
    $[24] = t10;
    $[25] = t11;
    $[26] = t2;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};